'use client';

import { c as _c } from "react/compiler-runtime";
import type { SpringOptions } from 'motion/react';
import { useRef, useState } from 'react';
import { motion, useMotionValue, useSpring } from 'motion/react';
import './TiltedCard.css';
type TiltedCardProps = {
  imageSrc: React.ComponentProps<'img'>['src'];
  altText?: string;
  captionText?: string;
  containerHeight?: React.CSSProperties['height'];
  containerWidth?: React.CSSProperties['width'];
  imageHeight?: React.CSSProperties['height'];
  imageWidth?: React.CSSProperties['width'];
  scaleOnHover?: number;
  rotateAmplitude?: number;
  showMobileWarning?: boolean;
  showTooltip?: boolean;
  overlayContent?: React.ReactNode;
  displayOverlayContent?: boolean;
};
const springValues: SpringOptions = {
  damping: 30,
  stiffness: 100,
  mass: 2
};
export default function TiltedCard(t0) {
  const $ = _c(59);
  const {
    imageSrc,
    altText: t1,
    captionText: t2,
    containerHeight: t3,
    containerWidth: t4,
    imageHeight: t5,
    imageWidth: t6,
    scaleOnHover: t7,
    rotateAmplitude: t8,
    showMobileWarning: t9,
    showTooltip: t10,
    overlayContent: t11,
    displayOverlayContent: t12
  } = t0;
  const altText = t1 === undefined ? "Tilted card image" : t1;
  const captionText = t2 === undefined ? "" : t2;
  const containerHeight = t3 === undefined ? "300px" : t3;
  const containerWidth = t4 === undefined ? "100%" : t4;
  const imageHeight = t5 === undefined ? "300px" : t5;
  const imageWidth = t6 === undefined ? "300px" : t6;
  const scaleOnHover = t7 === undefined ? 1.1 : t7;
  const rotateAmplitude = t8 === undefined ? 14 : t8;
  const showMobileWarning = t9 === undefined ? true : t9;
  const showTooltip = t10 === undefined ? true : t10;
  const overlayContent = t11 === undefined ? null : t11;
  const displayOverlayContent = t12 === undefined ? false : t12;
  const ref = useRef(null);
  const x = useMotionValue(0);
  const y = useMotionValue(0);
  const rotateX = useSpring(useMotionValue(0), springValues);
  const rotateY = useSpring(useMotionValue(0), springValues);
  const scale = useSpring(1, springValues);
  const opacity = useSpring(0);
  let t13;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      stiffness: 350,
      damping: 30,
      mass: 1
    };
    $[0] = t13;
  } else {
    t13 = $[0];
  }
  const rotateFigcaption = useSpring(0, t13);
  const [lastY, setLastY] = useState(0);
  let t14;
  if ($[1] !== lastY || $[2] !== rotateAmplitude || $[3] !== rotateFigcaption || $[4] !== rotateX || $[5] !== rotateY || $[6] !== x || $[7] !== y) {
    t14 = function handleMouse(e) {
      if (!ref.current) {
        return;
      }
      const rect = ref.current.getBoundingClientRect();
      const offsetX = e.clientX - rect.left - rect.width / 2;
      const offsetY = e.clientY - rect.top - rect.height / 2;
      const rotationX = offsetY / (rect.height / 2) * -rotateAmplitude;
      const rotationY = offsetX / (rect.width / 2) * rotateAmplitude;
      rotateX.set(rotationX);
      rotateY.set(rotationY);
      x.set(e.clientX - rect.left);
      y.set(e.clientY - rect.top);
      const velocityY = offsetY - lastY;
      rotateFigcaption.set(-velocityY * 0.6);
      setLastY(offsetY);
    };
    $[1] = lastY;
    $[2] = rotateAmplitude;
    $[3] = rotateFigcaption;
    $[4] = rotateX;
    $[5] = rotateY;
    $[6] = x;
    $[7] = y;
    $[8] = t14;
  } else {
    t14 = $[8];
  }
  const handleMouse = t14;
  let t15;
  if ($[9] !== opacity || $[10] !== scale || $[11] !== scaleOnHover) {
    t15 = function handleMouseEnter() {
      scale.set(scaleOnHover);
      opacity.set(1);
    };
    $[9] = opacity;
    $[10] = scale;
    $[11] = scaleOnHover;
    $[12] = t15;
  } else {
    t15 = $[12];
  }
  const handleMouseEnter = t15;
  let t16;
  if ($[13] !== opacity || $[14] !== rotateFigcaption || $[15] !== rotateX || $[16] !== rotateY || $[17] !== scale) {
    t16 = function handleMouseLeave() {
      opacity.set(0);
      scale.set(1);
      rotateX.set(0);
      rotateY.set(0);
      rotateFigcaption.set(0);
    };
    $[13] = opacity;
    $[14] = rotateFigcaption;
    $[15] = rotateX;
    $[16] = rotateY;
    $[17] = scale;
    $[18] = t16;
  } else {
    t16 = $[18];
  }
  const handleMouseLeave = t16;
  let t17;
  if ($[19] !== containerHeight || $[20] !== containerWidth) {
    t17 = {
      height: containerHeight,
      width: containerWidth
    };
    $[19] = containerHeight;
    $[20] = containerWidth;
    $[21] = t17;
  } else {
    t17 = $[21];
  }
  let t18;
  if ($[22] !== showMobileWarning) {
    t18 = showMobileWarning && <div className="tilted-card-mobile-alert">This effect is not optimized for mobile. Check on desktop.</div>;
    $[22] = showMobileWarning;
    $[23] = t18;
  } else {
    t18 = $[23];
  }
  let t19;
  if ($[24] !== imageHeight || $[25] !== imageWidth || $[26] !== rotateX || $[27] !== rotateY || $[28] !== scale) {
    t19 = {
      width: imageWidth,
      height: imageHeight,
      rotateX,
      rotateY,
      scale
    };
    $[24] = imageHeight;
    $[25] = imageWidth;
    $[26] = rotateX;
    $[27] = rotateY;
    $[28] = scale;
    $[29] = t19;
  } else {
    t19 = $[29];
  }
  let t20;
  if ($[30] !== imageHeight || $[31] !== imageWidth) {
    t20 = {
      width: imageWidth,
      height: imageHeight
    };
    $[30] = imageHeight;
    $[31] = imageWidth;
    $[32] = t20;
  } else {
    t20 = $[32];
  }
  let t21;
  if ($[33] !== altText || $[34] !== imageSrc || $[35] !== t20) {
    t21 = <motion.img src={imageSrc} alt={altText} className="tilted-card-img" style={t20} />;
    $[33] = altText;
    $[34] = imageSrc;
    $[35] = t20;
    $[36] = t21;
  } else {
    t21 = $[36];
  }
  let t22;
  if ($[37] !== displayOverlayContent || $[38] !== overlayContent) {
    t22 = displayOverlayContent && overlayContent && <motion.div className="tilted-card-overlay">{overlayContent}</motion.div>;
    $[37] = displayOverlayContent;
    $[38] = overlayContent;
    $[39] = t22;
  } else {
    t22 = $[39];
  }
  let t23;
  if ($[40] !== t19 || $[41] !== t21 || $[42] !== t22) {
    t23 = <motion.div className="tilted-card-inner" style={t19}>{t21}{t22}</motion.div>;
    $[40] = t19;
    $[41] = t21;
    $[42] = t22;
    $[43] = t23;
  } else {
    t23 = $[43];
  }
  let t24;
  if ($[44] !== captionText || $[45] !== opacity || $[46] !== rotateFigcaption || $[47] !== showTooltip || $[48] !== x || $[49] !== y) {
    t24 = showTooltip && <motion.figcaption className="tilted-card-caption" style={{
      x,
      y,
      opacity,
      rotate: rotateFigcaption
    }}>{captionText}</motion.figcaption>;
    $[44] = captionText;
    $[45] = opacity;
    $[46] = rotateFigcaption;
    $[47] = showTooltip;
    $[48] = x;
    $[49] = y;
    $[50] = t24;
  } else {
    t24 = $[50];
  }
  let t25;
  if ($[51] !== handleMouse || $[52] !== handleMouseEnter || $[53] !== handleMouseLeave || $[54] !== t17 || $[55] !== t18 || $[56] !== t23 || $[57] !== t24) {
    t25 = <figure ref={ref} className="tilted-card-figure" style={t17} onMouseMove={handleMouse} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>{t18}{t23}{t24}</figure>;
    $[51] = handleMouse;
    $[52] = handleMouseEnter;
    $[53] = handleMouseLeave;
    $[54] = t17;
    $[55] = t18;
    $[56] = t23;
    $[57] = t24;
    $[58] = t25;
  } else {
    t25 = $[58];
  }
  return t25;
}